import { Button } from "@/components/ui/button"
import { Slider } from "@/components/ui/slider"
import { useNapForm } from "../NapFormContext"

interface SleepLatencyStepProps {
  childName?: string
  onNext: () => void
  onPrev?: () => void
}

export function SleepLatencyStep({ childName, onNext, onPrev }: SleepLatencyStepProps) {
  // Access form through context
  const form = useNapForm();
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-center">
        How long did it take {childName || 'your baby'} to fall asleep?
      </h3>
      <div className="max-w-sm mx-auto space-y-6">
        <div className="space-y-4">
          <Slider
            min={0}
            max={60}
            step={1}
            value={[form.watch("sleep_latency") || 0]}
            onValueChange={(value) => {
              form.setValue("sleep_latency", value[0])
              form.clearErrors("sleep_latency")
            }}
            className="py-4 [&_[role=slider]]:bg-primary [&_[role=slider]]:h-7 [&_[role=slider]]:w-7 [&_[role=slider]]:border-4 [&_[role=slider]]:shadow-md [&_.SliderRange]:bg-purple-500 [&_.SliderTrack]:bg-slate-600/50 [&_.SliderTrack]:h-3"
          />
          <div className="text-center">
            <span className="text-2xl font-semibold">{form.watch("sleep_latency") || 0}</span>
            <span className="text-muted-foreground ml-2">minutes</span>
          </div>
        </div>
        {form.formState.errors.sleep_latency && (
          <p className="text-sm text-destructive text-center mt-1">
            {form.formState.errors.sleep_latency.message}
          </p>
        )}
        <div className="text-xs text-muted-foreground text-center">
          <p>Slide to adjust the time it took your baby to fall asleep</p>
          <p className="mt-1">Most babies take 5-20 minutes to fall asleep</p>
        </div>
      </div>
      
      <div className="flex justify-between pt-4">
        {onPrev && (
          <Button 
            type="button" 
            variant="outline" 
            onClick={onPrev}
            className="border-white/10 text-gray-300 hover:bg-white/5"
          >
            Back
          </Button>
        )}
        
        <Button
          type="button"
          onClick={onNext}
          className="ml-auto bg-purple-500 hover:bg-purple-600 text-white"
        >
          Continue
        </Button>
      </div>
    </div>
  )
}